import { ShoppingCartService } from "@/app/services";
import { AddressReducerStateType } from "@/app/types/address-reducer-state";
import { CartType } from "@/app/types/cart";
import { clearCart, setPriceChangedItems, startFetching, startLoading, stopFetching, stopLoading, updateCart } from "./cartSlice";
import { toast } from "sonner";

const clearCartThunk = (): any => async (dispatch: any) => {
	const cart = new ShoppingCartService();

	dispatch(startLoading());
	try {
		await cart.clear();
		dispatch(clearCart());
		dispatch(stopLoading());
	} catch (e) {
		dispatch(stopLoading());
	}
};

const _getCartThunk = (): any => async (dispatch: any) => {
	const cart = new ShoppingCartService();
	dispatch(startFetching());
	try {
		const res = await cart.fetch();
		const cartData = res?.data ?? null;
		dispatch(updateCart(cartData));
		dispatch(stopFetching());
	} catch (e) {
		dispatch(stopFetching());
	}
};

const getCartThunk =
	() =>
	async (dispatch: any): Promise<CartType> => {
		const cart = new ShoppingCartService();
		dispatch(startFetching());
		try {
			const res = await cart.fetch();
			const cartData = res?.data ?? null;
			dispatch(updateCart(cartData));
			dispatch(stopFetching());
			return cartData;
		} catch (e) {
			dispatch(stopFetching());
			throw e;
		}
	};

const addToCartThunk =
	(productId: number, qty: number = 1): any =>
	async (dispatch: any): Promise<boolean> => {
		const cart = new ShoppingCartService(productId);

		dispatch(startLoading());
		try {
			const { data: cartData } = await cart.add(qty);
			dispatch(updateCart(cartData));
			dispatch(stopLoading());
			return true;
		} catch (e: any) {
			dispatch(stopLoading());
			return false;
		}
	};

const removeFromCartThunk =
	(productId: number, qty: number = 1): any =>
	async (dispatch: any) => {
		const cart = new ShoppingCartService(productId);

		dispatch(startLoading());
		try {
			const { data: cartData } = await cart.remove(qty);
			dispatch(updateCart(cartData));
			dispatch(stopLoading());
			toast.success(`محصول مورد نظر از سبد خرید حذف گردید.`);
		} catch (e) {
			dispatch(stopLoading());
		}
	};

const buildPriceChangedItems = (newCart: CartType) => {
	if (!newCart.price_changes?.items?.length) return null;

	const enriched = newCart.price_changes.items.map(changed => {
		const cartItem = newCart.items.find(i => i.product.product_id === changed.product_id);
		return {
			product_name: changed.product_name,
			image: cartItem?.product?.images?.[0]?.link ?? null,
			old_price: changed.old_price,
			new_price: changed.new_price,
		};
	});

	return { items: enriched, changes: newCart.price_changes };
};

const addAddressThunk =
	(payload: AddressReducerStateType): any =>
	async (dispatch: any) => {
		const cart = new ShoppingCartService();

		dispatch(startLoading());
		try {
			const { data: cartData } = await cart.submitAddress(payload);
			const priceChanges = buildPriceChangedItems(cartData);
			if (priceChanges) dispatch(setPriceChangedItems(priceChanges));
			dispatch(updateCart(cartData));
			return true;
		} catch (e) {
			dispatch(stopLoading());
			return false;
		}
	};

const addCartDiscountThunk =
	(discountCode: string): any =>
	async (dispatch: any) => {
		const cart = new ShoppingCartService();

		dispatch(startLoading());
		try {
			const { data: cartData } = await cart.addDiscount(discountCode);
			const priceChanges = buildPriceChangedItems(cartData);
			if (priceChanges) dispatch(setPriceChangedItems(priceChanges));
			dispatch(updateCart(cartData));
			dispatch(stopLoading());
			toast.success("کد تخفیف به سبد خرید اضافه گردید.");
		} catch (e) {
			dispatch(stopLoading());
		}
	};

const removeCartDiscountThunk = (): any => async (dispatch: any) => {
	const cart = new ShoppingCartService();

	dispatch(startLoading());
	try {
		const { data: cartData } = await cart.removeDiscount();
		const priceChanges = buildPriceChangedItems(cartData);
		if (priceChanges) dispatch(setPriceChangedItems(priceChanges));
		dispatch(updateCart(cartData));
		dispatch(stopLoading());
		toast.success("کد تخفیف از سبد خرید حذف گردید.");
	} catch (e) {
		dispatch(stopLoading());
	}
};

export { addAddressThunk, addCartDiscountThunk, addToCartThunk, clearCartThunk, getCartThunk, removeCartDiscountThunk, removeFromCartThunk };
